import {Button, ButtonProps, useListContext, useNotify,} from "react-admin";
import PublishIcon from "@material-ui/icons/Print";
import {clientNoJson} from "../../dataProvider";
import {getFileNameFromContentDisposition} from "../../shared/utils";
import {useState} from "react";
import {CircularProgress} from "@material-ui/core";

export const DownloadContentBulkButton = (props: ButtonProps) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const { selectedIds, refetch } = useListContext();
  const handleSubmit = async (e: any) => {
    e.stopPropagation();
    setLoading(true);
    let res = null;
    try {
      res = await clientNoJson(`/api/bank_receipt/download_bank_receipt_content/`, {
        method: "POST",
        data: {
          ids: selectedIds,
        },
        responseType: "arraybuffer",
      }).finally(() => {
        setLoading(false)
      });
    } catch (err) {
      notify("ra.message.error", "error");
      setLoading(false);
      return;
    }
    const data = res.data; // or res.blob() if using blob responses

    const url = window.URL.createObjectURL(
      new Blob([data], {
        type: res.headers["content-type"],
      })
    );
    const actualFileName = getFileNameFromContentDisposition(
      res.headers["content-disposition"]
    );

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", actualFileName);
    document.body.appendChild(link);
    link.click();
    if (link.parentNode) link.parentNode.removeChild(link);
    try {
      refetch();
    }
    catch (e) {

    }
  };

  return (
    <Button
      {...props}
      disabled={loading}
      label="Export contenuto riba"
      onClick={handleSubmit}
    >
      {loading ? <CircularProgress size={18} thickness={2} /> : <PublishIcon />}
    </Button>
  );
};
